'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { LoadingImage } from '@7f-ui/components/loading-image/loading-image';
type PartnerImage = {
  url: string;
  alt: string;
};
type PartnerGalleryProps = {
  images: PartnerImage[];
};
const imageSizes = ['(min-width: 1024px) 33vw, 50vw', '(min-width: 1024px) 17vw, (min-width: 768px) 25vw, 33vw', '(min-width: 1024px) 17vw, (min-width: 768px) 25vw, 33vw', '(min-width: 1024px) 33vw, 50vw', '(min-width: 1024px) 45vw, 67vw', '(min-width: 1024px) 22vw, (min-width: 768px) 33vw, 33vw', '(min-width: 1024px) 28vw, (min-width: 768px) 42vw, 50vw', '(min-width: 1024px) 22vw, (min-width: 768px) 33vw, 50vw', '(min-width: 1024px) 22vw, (min-width: 768px) 33vw, 50vw', '(min-width: 1024px) 22vw, (min-width: 768px) 33vw, 100vw'] as const;
export function PartnerGallery(t0) {
  const $ = _c(4);
  const {
    images
  } = t0;
  if (images.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== images) {
    t1 = images.map(_temp);
    $[0] = images;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className="fluid-grid auto-rows-auto gap-y-4 md:gap-y-8">{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
function _temp(image, index) {
  return <div key={image.url} className={cx("relative aspect-square overflow-hidden rounded-2xl", {
    "col-span-3 col-start-1 row-span-3 row-start-1 sm:col-span-6 sm:row-span-6": index === 0,
    "col-span-2 col-start-4 row-span-2 row-start-1 sm:col-span-3 sm:row-span-3": index === 1,
    "col-span-2 col-start-2 row-span-2 row-start-4 sm:col-span-3 sm:col-start-4 sm:row-span-3 sm:row-start-7": index === 2,
    "col-span-3 col-start-4 row-span-3 row-start-3 sm:col-span-6 sm:row-span-6": index === 3,
    "col-span-4 col-start-1 row-span-4 row-start-6 sm:col-span-8 sm:row-span-8": index === 4,
    "col-span-2 col-start-5 row-span-2 row-start-6 sm:col-span-4 sm:row-span-4": index === 5,
    "col-span-3 col-start-3 row-span-3 sm:col-span-5 sm:col-start-6 sm:row-span-5": index === 6,
    "col-span-3 row-span-3 sm:col-span-4 sm:row-span-4": index === 7 || index === 8,
    "col-span-6 row-span-3 sm:col-span-4 sm:row-span-4": index === 9
  })}><LoadingImage src={image.url} alt={image.alt} fill={true} className="object-cover" sizes={imageSizes[index] ?? imageSizes[imageSizes.length - 1]} /></div>;
}